import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.256 11.25c.003-1.086.002-1.885 0-2.36a1.5 1.5 0 0 0 .994-1.412V5.632a2.5 2.5 0 0 0-2.402-2.498A193.29 193.29 0 0 0 12.34 3c-2.741 0-5.303.046-7.686.137A2.5 2.5 0 0 0 2.25 5.635v1.847c.003.65.417 1.202.995 1.409-.004.474-.004 1.274-.002 2.36l.003 1.136.003.995.001.609c0 1.318.031 2.472.094 3.465a3.5 3.5 0 0 0 3.204 3.268c2.225.184 4.133.276 5.727.276 1.59 0 3.482-.091 5.678-.274a3.5 3.5 0 0 0 3.203-3.268c.063-.993.094-2.149.094-3.467l.001-.607.003-.995.002-1.139ZM16.25 8.982h4.006a362.777 362.777 0 0 1-.002 3.404l-.003.996-.001.609c0 1.299-.03 2.434-.092 3.404a2.5 2.5 0 0 1-2.288 2.334c-2.17.18-4.036.271-5.595.271-1.564 0-3.446-.09-5.644-.273a2.5 2.5 0 0 1-2.29-2.334 54.87 54.87 0 0 1-.091-3.402l-.001-.611-.003-.996-.003-1.135a352.54 352.54 0 0 1 .001-2.267H16.25ZM4.693 4.136a1.5 1.5 0 0 0-1.443 1.5V7.48a.5.5 0 0 0 .502.498 621.97 621.97 0 0 1 6.83-.005c.574.006 2.79.006 3.355 0a678.23 678.23 0 0 1 6.813.005.5.5 0 0 0 .5-.5V5.632a1.5 1.5 0 0 0-1.441-1.499A192.323 192.323 0 0 0 12.34 4c-2.729 0-5.278.045-7.647.136Zm4.883 9.958a.338.338 0 0 1-.477-.478l2.442-2.435a1.181 1.181 0 0 1 1.67 0l2.44 2.442a.338.338 0 0 1-.477.478l-2.44-2.442a.511.511 0 0 0-.052-.045v6.022a.307.307 0 1 1-.614 0v-6.021a.504.504 0 0 0-.05.043l-2.442 2.436Z",
      clipRule: "evenodd"
    }
  )
);
var SvgUnarchiveOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var UnarchiveOutlined_default = SvgUnarchiveOutlined;

export { UnarchiveOutlined_default as default };
